import React, { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PoweroffOutlined, UnlockOutlined } from '@ant-design/icons'
import { Popconfirm, Drawer } from 'antd'
import { useUserInfoContext } from '@/store/userInfo'
import ChangePassword from './ChangePassword'
import {drawerWidth} from '@/config/config'
import TopNav from './TopNav'
import logo from '@/assets/images/logo.png'
import styles from '../style.module.less'

const Head = ({onTopMenu}) => {
  const userInfo = useUserInfoContext()
  const navigator = useNavigate()
  const [passwordVisible, setPasswordVisible] = useState(false)

  const logout = useCallback(() => {
    userInfo.clear()
    navigator('/login', {
      replace: true
    })
  }, [userInfo, navigator])

  const handleClosePassword = useCallback(() => {
      setPasswordVisible(false)
  }, [])

  return (
    <div className={`primary-bg text-white flex align-center plr-10 ${styles.head}`}>
      <div className='font-12 mr-30'>
        <img className={styles.logo} src={logo} alt="" />
      </div>
      <TopNav onChange={onTopMenu} />
      <div className='flex-1'></div>
      <UnlockOutlined className='mr-20' onClick={() => setPasswordVisible(true)} />
      <Popconfirm title="确定要退出吗？" onConfirm={logout}>
        <PoweroffOutlined className='mr-20 cursor-pointer' />
      </Popconfirm>
      <div className='mr-20'>{userInfo.baseInfo.name}</div>
      <Drawer 
        title='修改密码' 
        width={drawerWidth} 
        onClose={handleClosePassword} 
        open={passwordVisible}
        className='custom-drawer'
        destroyOnClose
        >
          <ChangePassword onCancel={handleClosePassword}/>
      </Drawer>
    </div>
  )
}

export default Head
